import { InjectionToken } from '@angular/core';
import { RoleServiceInterface } from '@core/auth/role.interface';
import { AuthServiceInterface } from '@core/auth/auth.interface';

export const ROLE_SERVICE = new InjectionToken<RoleServiceInterface>('ROLE_SERVICE');
export const AUTH_SERVICE = new InjectionToken<AuthServiceInterface>('AUTH_SERVICE');
